import { randomUuid } from './uuid';

const STORAGE_KEY = 'nbh.deviceId';

/**
 * A stable id for this browser profile (decision D18).
 *
 * Not a credential and not a secret — it lets the server bound how far this device
 * may backdate a report, using its own last successful sync. Kept in localStorage
 * rather than IndexedDB so it is available synchronously on the very first request,
 * before Dexie has opened.
 *
 * Clearing site data resets it, which is the safe direction: the device looks new,
 * has no sync history, and its first report is simply taken at face value.
 */
export function getDeviceId(): string {
  try {
    const existing = localStorage.getItem(STORAGE_KEY);
    if (existing) return existing;

    const created = randomUuid();
    localStorage.setItem(STORAGE_KEY, created);
    return created;
  } catch {
    // Private browsing or blocked storage. A per-session id still identifies this
    // tab for the life of the page; it just carries no history across reloads.
    return randomUuid();
  }
}
